import { render, staticRenderFns } from "./PaymentConfirm.vue?vue&type=template&id=124d5cf0&scoped=true"
import script from "./PaymentConfirm.vue?vue&type=script&lang=js"
export * from "./PaymentConfirm.vue?vue&type=script&lang=js"
import style0 from "./PaymentConfirm.vue?vue&type=style&index=0&id=124d5cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d5cf0",
  null
  
)

export default component.exports